"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import * as _utils from "./utils";
import _styles from "./2024CommunityHeader.module.css";

const _interactionsData = JSON.parse(
  '{"events":{"e-778":{"id":"e-778","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-284","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-779"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".waves---expandable-item-4","originalId":"62d6c03a6672f738121c205d|4f7015af-b754-4c2e-f5d8-1e5018ee5cf6","appliesTo":"CLASS"},"targets":[{"selector":".waves---expandable-item-4","originalId":"62d6c03a6672f738121c205d|4f7015af-b754-4c2e-f5d8-1e5018ee5cf6","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1658243815639},"e-779":{"id":"e-779","name":"","animationType":"custom","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-285","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-778"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".waves---expandable-item-4","originalId":"62d6c03a6672f738121c205d|4f7015af-b754-4c2e-f5d8-1e5018ee5cf6","appliesTo":"CLASS"},"targets":[{"selector":".waves---expandable-item-4","originalId":"62d6c03a6672f738121c205d|4f7015af-b754-4c2e-f5d8-1e5018ee5cf6","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1658243815641},"e-780":{"id":"e-780","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-283","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-781"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"67ca2531127465ea8b62d9c6|b943e545-5657-5d37-7229-2eb0048185e8","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"67ca2531127465ea8b62d9c6|b943e545-5657-5d37-7229-2eb0048185e8","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1741424869010},"e-782":{"id":"e-782","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-282","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-783"}},"mediaQueries":["main"],"target":{"id":"67ca2531127465ea8b62d9c6|681af101-cddb-194d-d7d1-1acb8c11a1b3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"67ca2531127465ea8b62d9c6|681af101-cddb-194d-d7d1-1acb8c11a1b3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1741424976760},"e-783":{"id":"e-783","name":"","animationType":"custom","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-283","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-782"}},"mediaQueries":["main"],"target":{"id":"67ca2531127465ea8b62d9c6|681af101-cddb-194d-d7d1-1acb8c11a1b3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"67ca2531127465ea8b62d9c6|681af101-cddb-194d-d7d1-1acb8c11a1b3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1741424976762},"e-784":{"id":"e-784","name":"","animationType":"preset","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-282","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-785"}},"mediaQueries":["main"],"target":{"id":"fe0f57d7-58a8-c969-2657-34205c1d7774","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"fe0f57d7-58a8-c969-2657-34205c1d7774","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1741546261118},"e-785":{"id":"e-785","name":"","animationType":"preset","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-283","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-784"}},"mediaQueries":["main"],"target":{"id":"fe0f57d7-58a8-c969-2657-34205c1d7774","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"fe0f57d7-58a8-c969-2657-34205c1d7774","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1741546261118},"e-786":{"id":"e-786","name":"","animationType":"preset","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-283","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-787"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"fe0f57d7-58a8-c969-2657-34205c1d78a8","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"fe0f57d7-58a8-c969-2657-34205c1d78a8","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1741546261118}},"actionLists":{"a-284":{"id":"a-284","title":"WAVES / Expand 3","actionItemGroups":[{"actionItems":[{"id":"a-284-n","actionTypeId":"STYLE_SIZE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".waves---expandable-open-4","selectorGuids":["90aa04c2-857a-caaa-c5b8-a12140110692"]},"heightValue":0,"widthUnit":"PX","heightUnit":"px","locked":false}},{"id":"a-284-n-2","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".waves---expand-icon-wrap-4","selectorGuids":["90aa04c2-857a-caaa-c5b8-a12140110696"]},"xValue":0,"zValue":null,"xUnit":"deg","yUnit":"DEG","zUnit":"deg"}},{"id":"a-284-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".waves---expandable-open-4","selectorGuids":["90aa04c2-857a-caaa-c5b8-a12140110692"]},"value":0,"unit":""}},{"id":"a-284-n-4","actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".waves---expandable-open-4","selectorGuids":["90aa04c2-857a-caaa-c5b8-a12140110692"]},"xValue":1,"yValue":0,"locked":false}}]},{"actionItems":[{"id":"a-284-n-5","actionTypeId":"STYLE_SIZE","config":{"delay":0,"easing":"easeOut","duration":300,"target":{"useEventTarget":"CHILDREN","selector":".waves---expandable-open-4","selectorGuids":["90aa04c2-857a-caaa-c5b8-a12140110692"]},"widthUnit":"PX","heightUnit":"AUTO","locked":false}},{"id":"a-284-n-6","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"easeOut","duration":300,"target":{"useEventTarget":"CHILDREN","selector":".waves---expand-icon-wrap-4","selectorGuids":["90aa04c2-857a-caaa-c5b8-a12140110696"]},"xValue":180,"yValue":null,"zValue":null,"xUnit":"deg","yUnit":"deg","zUnit":"deg"}},{"id":"a-284-n-7","actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"easing":"easeOut","duration":300,"target":{"useEventTarget":"CHILDREN","selector":".waves---expandable-open-4","selectorGuids":["90aa04c2-857a-caaa-c5b8-a12140110692"]},"xValue":1,"yValue":1,"locked":true}},{"id":"a-284-n-8","actionTypeId":"STYLE_OPACITY","config":{"delay":200,"easing":"","duration":300,"target":{"useEventTarget":"CHILDREN","selector":".waves---expandable-open-4","selectorGuids":["90aa04c2-857a-caaa-c5b8-a12140110692"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1658242693387},"a-285":{"id":"a-285","title":"WAVES / Collapse 3","actionItemGroups":[{"actionItems":[{"id":"a-285-n","actionTypeId":"STYLE_SIZE","config":{"delay":0,"easing":"ease","duration":300,"target":{"useEventTarget":"CHILDREN","selector":".waves---expandable-open-4","selectorGuids":["90aa04c2-857a-caaa-c5b8-a12140110692"]},"heightValue":0,"widthUnit":"PX","heightUnit":"px","locked":false}},{"id":"a-285-n-2","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"ease","duration":300,"target":{"useEventTarget":"CHILDREN","selector":".waves---expand-icon-wrap-4","selectorGuids":["90aa04c2-857a-caaa-c5b8-a12140110696"]},"xValue":0,"zValue":null,"xUnit":"deg","yUnit":"DEG","zUnit":"deg"}},{"id":"a-285-n-3","actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"easing":"ease","duration":400,"target":{"useEventTarget":"CHILDREN","selector":".waves---expandable-open-4","selectorGuids":["90aa04c2-857a-caaa-c5b8-a12140110692"]},"yValue":0,"locked":false}},{"id":"a-285-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".waves---expandable-open-4","selectorGuids":["90aa04c2-857a-caaa-c5b8-a12140110692"]},"value":0,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1658242693387},"a-283":{"id":"a-283","title":"Megamenu Close","actionItemGroups":[{"actionItems":[{"id":"a-283-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutSine","duration":200,"target":{"selector":".flex-block-19","selectorGuids":["d08234a0-7858-2d07-729f-a6939a68ddf3"]},"yValue":20,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-283-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"inOutSine","duration":200,"target":{"selector":".flex-block-19","selectorGuids":["d08234a0-7858-2d07-729f-a6939a68ddf3"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-283-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".flex-block-19","selectorGuids":["d08234a0-7858-2d07-729f-a6939a68ddf3"]},"value":"none"}}]},{"actionItems":[{"id":"a-283-n-9","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":300,"target":{"selector":".div-block-134","selectorGuids":["b616cd35-2447-6c55-efe9-fc18244b8d32"]},"value":0,"unit":""}},{"id":"a-283-n-8","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".div-block-134","selectorGuids":["b616cd35-2447-6c55-efe9-fc18244b8d32"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1741380519178},"a-282":{"id":"a-282","title":"Megamenu Open","actionItemGroups":[{"actionItems":[{"id":"a-282-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".flex-block-19","selectorGuids":["d08234a0-7858-2d07-729f-a6939a68ddf3"]},"value":"none"}},{"id":"a-282-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutSine","duration":500,"target":{"selector":".flex-block-19","selectorGuids":["d08234a0-7858-2d07-729f-a6939a68ddf3"]},"yValue":20,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-282-n-5","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".flex-block-19","selectorGuids":["d08234a0-7858-2d07-729f-a6939a68ddf3"]},"value":0,"unit":""}},{"id":"a-282-n-7","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".div-block-134","selectorGuids":["b616cd35-2447-6c55-efe9-fc18244b8d32"]},"value":"none"}},{"id":"a-282-n-9","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".div-block-134","selectorGuids":["b616cd35-2447-6c55-efe9-fc18244b8d32"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-282-n-8","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".div-block-134","selectorGuids":["b616cd35-2447-6c55-efe9-fc18244b8d32"]},"value":"block"}},{"id":"a-282-n-10","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"inOutCubic","duration":300,"target":{"selector":".div-block-134","selectorGuids":["b616cd35-2447-6c55-efe9-fc18244b8d32"]},"value":1,"unit":""}},{"id":"a-282-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".flex-block-19","selectorGuids":["d08234a0-7858-2d07-729f-a6939a68ddf3"]},"value":"flex"}},{"id":"a-282-n-4","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutSine","duration":200,"target":{"selector":".flex-block-19","selectorGuids":["d08234a0-7858-2d07-729f-a6939a68ddf3"]},"yValue":0,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-282-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"inOutSine","duration":200,"target":{"selector":".flex-block-19","selectorGuids":["d08234a0-7858-2d07-729f-a6939a68ddf3"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1741380519178}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function __2024CommunityHeader({ as: _Component = _Builtin.Section }) {
  _interactions.useInteractions(_interactionsData, _styles);

  return (
    <_Component
      className={_utils.cx(_styles, "section-27")}
      grid={{
        type: "section",
      }}
      tag="section"
    >
      <_Builtin.NavbarWrapper
        className={_utils.cx(_styles, "", "navbar")}
        tag="div"
        config={{
          easing: "ease",
          easing2: "ease",
          duration: 400,
          docHeight: true,
          noScroll: true,
          animation: "over-left",
          collapse: "medium",
        }}
      >
        <_Builtin.Block
          className={_utils.cx(_styles, "", "div-block-83")}
          tag="div"
        >
          <_Builtin.NavbarBrand
            className={_utils.cx(_styles, "brand")}
            options={{
              href: "http://engineears.com",
            }}
          >
            <_Builtin.Image
              className={_utils.cx(_styles, "image-77")}
              width="Auto"
              height="auto"
              loading="lazy"
              alt=""
              src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/6356e76f5d817f20c168ee23_Wordmark-webflow.svg"
            />
          </_Builtin.NavbarBrand>
          <_Builtin.List
            className={_utils.cx(_styles, "nav-menu-two-4")}
            tag="ul"
            unstyled={true}
          >
            <_Builtin.ListItem
              className={_utils.cx(_styles, "list-item-19")}
              data-w-id="fe0f57d7-58a8-c969-2657-34205c1d7774"
            >
              <_Builtin.Link
                className={_utils.cx(_styles, "nav-link-8")}
                button={false}
                block=""
                options={{
                  href: "#",
                }}
              >
                {"Product"}
              </_Builtin.Link>
              <_Builtin.Icon
                className={_utils.cx(_styles, "icon")}
                widget={{
                  type: "icon",
                  icon: "dropdown-toggle",
                }}
              />
            </_Builtin.ListItem>
            <_Builtin.ListItem>
              <_Builtin.DropdownWrapper
                className={_utils.cx(_styles, "nav-dropdown-3")}
                tag="div"
                delay={0}
                hover={false}
              >
                <_Builtin.DropdownToggle
                  className={_utils.cx(_styles, "nav-dropdown-toggle-3")}
                  tag="div"
                >
                  <_Builtin.Icon
                    className={_utils.cx(_styles, "nav-dropdown-icon-3")}
                    widget={{
                      type: "icon",
                      icon: "dropdown-toggle",
                    }}
                  />
                  <_Builtin.Block tag="div">{"Learn"}</_Builtin.Block>
                </_Builtin.DropdownToggle>
                <_Builtin.DropdownList
                  className={_utils.cx(
                    _styles,
                    "nav-dropdown-list-3",
                    "shadow-three",
                    "mobile-shadow-hide"
                  )}
                  tag="nav"
                >
                  <_Builtin.DropdownLink
                    className={_utils.cx(_styles, "nav-dropdown-link-3")}
                    options={{
                      href: "https://support.engineears.com/",
                    }}
                  >
                    {"Help Center"}
                  </_Builtin.DropdownLink>
                  <_Builtin.DropdownLink
                    className={_utils.cx(_styles, "nav-dropdown-link-3")}
                    options={{
                      href: "https://community.engineears.com/case-studies",
                    }}
                  >
                    {"Case Studies"}
                  </_Builtin.DropdownLink>
                  <_Builtin.DropdownLink
                    className={_utils.cx(_styles, "nav-dropdown-link-3")}
                    options={{
                      href: "https://engineears.com/community",
                    }}
                  >
                    {"Community"}
                  </_Builtin.DropdownLink>
                  <_Builtin.DropdownLink
                    className={_utils.cx(_styles, "nav-dropdown-link-3")}
                    options={{
                      href: "https://blog.engineears.com/",
                    }}
                  >
                    {"Blog"}
                  </_Builtin.DropdownLink>
                  <_Builtin.DropdownLink
                    className={_utils.cx(_styles, "nav-dropdown-link-3")}
                    options={{
                      href: "https://engineears.com/dolbyatmos",
                    }}
                  >
                    {"DolbyAtmos Certification"}
                  </_Builtin.DropdownLink>
                  <_Builtin.Link
                    className={_utils.cx(_styles, "nav-dropdown-link-3")}
                    button={false}
                    block="inline"
                    options={{
                      href: "https://engineears.com/protools",
                    }}
                  >
                    <_Builtin.Block tag="div">
                      {"Pro Tools Course"}
                    </_Builtin.Block>
                  </_Builtin.Link>
                </_Builtin.DropdownList>
              </_Builtin.DropdownWrapper>
            </_Builtin.ListItem>
            <_Builtin.ListItem>
              <_Builtin.Link
                className={_utils.cx(_styles, "nav-link-8")}
                button={false}
                block=""
                options={{
                  href: "https://engineears.com/add-subscription",
                }}
              >
                {"Pricing"}
              </_Builtin.Link>
            </_Builtin.ListItem>
            <_Builtin.ListItem>
              <_Builtin.NavbarLink
                className={_utils.cx(_styles, "nav-link-4", "outline")}
                options={{
                  href: "https://engineears.com/signup?flow=6&step=3",
                }}
              >
                {"Sign Up"}
              </_Builtin.NavbarLink>
            </_Builtin.ListItem>
            <_Builtin.ListItem
              className={_utils.cx(_styles, "mobile-margin-top-12")}
            >
              <_Builtin.NavbarLink
                className={_utils.cx(_styles, "nav-link-4")}
                options={{
                  href: "https://engineears.com/signin?flow=1&step=1",
                }}
              >
                {"Login"}
              </_Builtin.NavbarLink>
            </_Builtin.ListItem>
          </_Builtin.List>
          <_Builtin.NavbarMenu
            className={_utils.cx(_styles, "nav-menu")}
            tag="nav"
            role="navigation"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "div-block-115")}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "div-block-118")}
                tag="div"
              >
                <_Builtin.NavbarBrand
                  className={_utils.cx(_styles, "brand", "small-variant")}
                  options={{
                    href: "http://engineears.com",
                  }}
                >
                  <_Builtin.Image
                    className={_utils.cx(_styles, "image-77", "small-variant")}
                    width="Auto"
                    height="auto"
                    loading="lazy"
                    alt=""
                    src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/6356e76f5d817f20c168ee23_Wordmark-webflow.svg"
                  />
                </_Builtin.NavbarBrand>
                <_Builtin.NavbarButton
                  className={_utils.cx(
                    _styles,
                    "",
                    "menu-button-4",
                    "small-variant"
                  )}
                  tag="div"
                >
                  <_Builtin.Image
                    className={_utils.cx(_styles, "image-93")}
                    width="Auto"
                    height="auto"
                    loading="lazy"
                    alt=""
                    src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/67a516061691a97a23e2bfb1_x-close-icon.svg"
                  />
                </_Builtin.NavbarButton>
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "div-block-119")}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "div-block-117")}
                  tag="div"
                />
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "waves-expandable-master-faq-4")}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "waves---expandable-wrap-4")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "waves---expandable-item-4")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "waves---expandable-content-4"
                      )}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(
                          _styles,
                          "div-block-127",
                          "mobile"
                        )}
                        tag="div"
                      >
                        <_Builtin.Block
                          className={_utils.cx(_styles, "div-block-130")}
                          tag="div"
                        >
                          <_Builtin.Image
                            loading="lazy"
                            width="auto"
                            height="auto"
                            alt=""
                            src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/67ca3b086f3140c39a80fac6_Icon.svg"
                          />
                        </_Builtin.Block>
                        <_Builtin.Heading
                          className={_utils.cx(_styles, "heading-48")}
                          tag="h4"
                        >
                          {"Artists"}
                        </_Builtin.Heading>
                        <_Builtin.Block
                          className={_utils.cx(
                            _styles,
                            "waves---expand-icon-wrap-4"
                          )}
                          tag="div"
                        >
                          <_Builtin.Image
                            className={_utils.cx(_styles, "image-95")}
                            loading="lazy"
                            width="auto"
                            height="auto"
                            alt=""
                            src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/67cde0eef5f80de7bed45df2_angle-down%20f107%20regular.svg"
                          />
                        </_Builtin.Block>
                      </_Builtin.Block>
                      <_Builtin.Block
                        className={_utils.cx(
                          _styles,
                          "waves---expandable-open-4"
                        )}
                        tag="div"
                      >
                        <_Builtin.Link
                          className={_utils.cx(
                            _styles,
                            "nav-dropdown-link-3",
                            "mobile"
                          )}
                          button={false}
                          block="inline"
                          options={{
                            href: "https://engineears.com/customize-your-profile-for-artists",
                          }}
                        >
                          <_Builtin.Block tag="div">
                            {"Build Your Profile"}
                          </_Builtin.Block>
                        </_Builtin.Link>
                        <_Builtin.Link
                          className={_utils.cx(
                            _styles,
                            "nav-dropdown-link-3",
                            "mobile"
                          )}
                          button={false}
                          block="inline"
                          options={{
                            href: "https://engineears.com/booking-engineering-services",
                          }}
                        >
                          <_Builtin.Block tag="div">
                            {"Booking Engineering Services"}
                          </_Builtin.Block>
                        </_Builtin.Link>
                        <_Builtin.Link
                          className={_utils.cx(
                            _styles,
                            "nav-dropdown-link-3",
                            "mobile"
                          )}
                          button={false}
                          block="inline"
                          options={{
                            href: "https://engineears.com/booking-studio-sessions",
                          }}
                        >
                          <_Builtin.Block tag="div">
                            {"Book Recording Studios"}
                          </_Builtin.Block>
                        </_Builtin.Link>
                        <_Builtin.Link
                          className={_utils.cx(
                            _styles,
                            "nav-dropdown-link-3",
                            "mobile"
                          )}
                          button={false}
                          block="inline"
                          options={{
                            href: "https://engineears.com/project-management-tools-for-artists",
                          }}
                        >
                          <_Builtin.Block tag="div">
                            {"Project Management Tools"}
                          </_Builtin.Block>
                        </_Builtin.Link>
                        <_Builtin.Link
                          className={_utils.cx(
                            _styles,
                            "nav-dropdown-link-3",
                            "mobile"
                          )}
                          button={false}
                          block="inline"
                          options={{
                            href: "https://engineears.com/reporting-analytics-for-artists",
                          }}
                        >
                          <_Builtin.Block tag="div">
                            {"Reporting & Analytics"}
                          </_Builtin.Block>
                        </_Builtin.Link>
                        <_Builtin.Link
                          className={_utils.cx(
                            _styles,
                            "nav-dropdown-link-3",
                            "mobile"
                          )}
                          button={false}
                          block="inline"
                          options={{
                            href: "https://engineears.com/symphony",
                          }}
                        >
                          <_Builtin.Block tag="div">
                            {"Create Ad Campaigns"}
                          </_Builtin.Block>
                        </_Builtin.Link>
                      </_Builtin.Block>
                    </_Builtin.Block>
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(_styles, "waves---expandable-item-4")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "waves---expandable-content-4"
                      )}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(
                          _styles,
                          "div-block-127",
                          "mobile"
                        )}
                        tag="div"
                      >
                        <_Builtin.Block
                          className={_utils.cx(_styles, "div-block-130")}
                          tag="div"
                        >
                          <_Builtin.Image
                            loading="lazy"
                            width="auto"
                            height="auto"
                            alt=""
                            src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/67ca3b08f53a97b7279b6ca7_Icon-1.svg"
                          />
                        </_Builtin.Block>
                        <_Builtin.Heading
                          className={_utils.cx(_styles, "heading-48")}
                          tag="h4"
                        >
                          {"Audio Engineers"}
                        </_Builtin.Heading>
                        <_Builtin.Block
                          className={_utils.cx(
                            _styles,
                            "waves---expand-icon-wrap-4"
                          )}
                          tag="div"
                        >
                          <_Builtin.Image
                            className={_utils.cx(_styles, "image-95")}
                            loading="lazy"
                            width="auto"
                            height="auto"
                            alt=""
                            src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/67cde0eef5f80de7bed45df2_angle-down%20f107%20regular.svg"
                          />
                        </_Builtin.Block>
                      </_Builtin.Block>
                      <_Builtin.Block
                        className={_utils.cx(
                          _styles,
                          "waves---expandable-open-4"
                        )}
                        tag="div"
                      >
                        <_Builtin.Link
                          className={_utils.cx(
                            _styles,
                            "nav-dropdown-link-3",
                            "mobile"
                          )}
                          button={false}
                          block="inline"
                          options={{
                            href: "https://engineears.com/build-your-profile-for-engineers",
                          }}
                        >
                          <_Builtin.Block tag="div">
                            {"Build Your Profile"}
                          </_Builtin.Block>
                        </_Builtin.Link>
                        <_Builtin.Link
                          className={_utils.cx(
                            _styles,
                            "nav-dropdown-link-3",
                            "mobile"
                          )}
                          button={false}
                          block="inline"
                          options={{
                            href: "https://engineears.com/project-management-tools",
                          }}
                        >
                          <_Builtin.Block tag="div">
                            {"Project Management Tools"}
                          </_Builtin.Block>
                        </_Builtin.Link>
                        <_Builtin.Link
                          className={_utils.cx(
                            _styles,
                            "nav-dropdown-link-3",
                            "mobile"
                          )}
                          button={false}
                          block="inline"
                          options={{
                            href: "https://engineears.com/reporting-analytics",
                          }}
                        >
                          <_Builtin.Block tag="div">
                            {"Reporting & Analytics"}
                          </_Builtin.Block>
                        </_Builtin.Link>
                        <_Builtin.Link
                          className={_utils.cx(
                            _styles,
                            "nav-dropdown-link-3",
                            "mobile"
                          )}
                          button={false}
                          block="inline"
                          options={{
                            href: "https://engineears.com/symphony",
                          }}
                        >
                          <_Builtin.Block tag="div">
                            {"Create Ad Campaigns"}
                          </_Builtin.Block>
                        </_Builtin.Link>
                        <_Builtin.Link
                          className={_utils.cx(
                            _styles,
                            "nav-dropdown-link-3",
                            "mobile"
                          )}
                          button={false}
                          block="inline"
                          options={{
                            href: "https://engineears.com/dolbyatmos",
                          }}
                        >
                          <_Builtin.Block tag="div">
                            {"Dolby Atmos Course"}
                          </_Builtin.Block>
                        </_Builtin.Link>
                        <_Builtin.Link
                          className={_utils.cx(
                            _styles,
                            "nav-dropdown-link-3",
                            "mobile"
                          )}
                          button={false}
                          block="inline"
                          options={{
                            href: "https://engineears.com/protools",
                          }}
                        >
                          <_Builtin.Block tag="div">
                            {"Pro Tools Course"}
                          </_Builtin.Block>
                        </_Builtin.Link>
                      </_Builtin.Block>
                    </_Builtin.Block>
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(_styles, "waves---expandable-item-4")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "waves---expandable-content-4"
                      )}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(
                          _styles,
                          "div-block-127",
                          "mobile"
                        )}
                        tag="div"
                      >
                        <_Builtin.Block
                          className={_utils.cx(_styles, "div-block-130")}
                          tag="div"
                        >
                          <_Builtin.Image
                            loading="lazy"
                            width="auto"
                            height="auto"
                            alt=""
                            src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/67ca3b088baaecb3a94dc905_Icon-2.svg"
                          />
                        </_Builtin.Block>
                        <_Builtin.Heading
                          className={_utils.cx(_styles, "heading-48")}
                          tag="h4"
                        >
                          {"For Recording Studios"}
                        </_Builtin.Heading>
                        <_Builtin.Block
                          className={_utils.cx(
                            _styles,
                            "waves---expand-icon-wrap-4"
                          )}
                          tag="div"
                        >
                          <_Builtin.Image
                            className={_utils.cx(_styles, "image-95")}
                            loading="lazy"
                            width="auto"
                            height="auto"
                            alt=""
                            src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/67cde0eef5f80de7bed45df2_angle-down%20f107%20regular.svg"
                          />
                        </_Builtin.Block>
                      </_Builtin.Block>
                      <_Builtin.Block
                        className={_utils.cx(
                          _styles,
                          "waves---expandable-open-4"
                        )}
                        tag="div"
                      >
                        <_Builtin.Link
                          className={_utils.cx(
                            _styles,
                            "nav-dropdown-link-3",
                            "mobile"
                          )}
                          button={false}
                          block="inline"
                          options={{
                            href: "https://engineears.com/build-your-profile-for-studios",
                          }}
                        >
                          <_Builtin.Block tag="div">
                            {"Build Your Profile"}
                          </_Builtin.Block>
                        </_Builtin.Link>
                        <_Builtin.Link
                          className={_utils.cx(
                            _styles,
                            "nav-dropdown-link-3",
                            "mobile"
                          )}
                          button={false}
                          block="inline"
                          options={{
                            href: "https://engineears.com/session-management-tools",
                          }}
                        >
                          <_Builtin.Block tag="div">
                            {"Session Management Tools"}
                          </_Builtin.Block>
                        </_Builtin.Link>
                        <_Builtin.Link
                          className={_utils.cx(
                            _styles,
                            "nav-dropdown-link-3",
                            "mobile"
                          )}
                          button={false}
                          block="inline"
                          options={{
                            href: "https://engineears.com/studio-teams-resources",
                          }}
                        >
                          <_Builtin.Block tag="div">
                            {"Studio Team & Resources"}
                          </_Builtin.Block>
                        </_Builtin.Link>
                        <_Builtin.Link
                          className={_utils.cx(
                            _styles,
                            "nav-dropdown-link-3",
                            "mobile"
                          )}
                          button={false}
                          block="inline"
                          options={{
                            href: "http://reporting-analytics-for-studios",
                          }}
                        >
                          <_Builtin.Block tag="div">
                            {"Reporting & Analytics"}
                          </_Builtin.Block>
                        </_Builtin.Link>
                        <_Builtin.Link
                          className={_utils.cx(
                            _styles,
                            "nav-dropdown-link-3",
                            "mobile"
                          )}
                          button={false}
                          block="inline"
                          options={{
                            href: "https://engineears.com/symphony",
                          }}
                        >
                          <_Builtin.Block tag="div">
                            {"Create Ad Campaigns"}
                          </_Builtin.Block>
                        </_Builtin.Link>
                      </_Builtin.Block>
                    </_Builtin.Block>
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(_styles, "waves---expandable-item-4")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "waves---expandable-content-4"
                      )}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(
                          _styles,
                          "div-block-127",
                          "mobile"
                        )}
                        tag="div"
                      >
                        <_Builtin.Block
                          className={_utils.cx(_styles, "div-block-130")}
                          tag="div"
                        >
                          <_Builtin.Image
                            loading="lazy"
                            width="auto"
                            height="auto"
                            alt=""
                            src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/67ca3b08f1ec198286a0b6a5_Icon-3.svg"
                          />
                        </_Builtin.Block>
                        <_Builtin.Heading
                          className={_utils.cx(_styles, "heading-48")}
                          tag="h4"
                        >
                          {"For Record Labels"}
                        </_Builtin.Heading>
                        <_Builtin.Block
                          className={_utils.cx(
                            _styles,
                            "waves---expand-icon-wrap-4"
                          )}
                          tag="div"
                        >
                          <_Builtin.Image
                            className={_utils.cx(_styles, "image-95")}
                            loading="lazy"
                            width="auto"
                            height="auto"
                            alt=""
                            src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/67cde0eef5f80de7bed45df2_angle-down%20f107%20regular.svg"
                          />
                        </_Builtin.Block>
                      </_Builtin.Block>
                      <_Builtin.Block
                        className={_utils.cx(
                          _styles,
                          "waves---expandable-open-4"
                        )}
                        tag="div"
                      >
                        <_Builtin.Link
                          className={_utils.cx(
                            _styles,
                            "nav-dropdown-link-3",
                            "mobile"
                          )}
                          button={false}
                          block="inline"
                          options={{
                            href: "https://engineears.com/getting-started-for-labels",
                          }}
                        >
                          <_Builtin.Block tag="div">
                            {"Getting Started"}
                          </_Builtin.Block>
                        </_Builtin.Link>
                        <_Builtin.Link
                          className={_utils.cx(
                            _styles,
                            "nav-dropdown-link-3",
                            "mobile"
                          )}
                          button={false}
                          block="inline"
                          options={{
                            href: "https://engineears.com/book-audio-engineering-services-for-labels",
                          }}
                        >
                          <_Builtin.Block tag="div">
                            {"Booking Engineering Services"}
                          </_Builtin.Block>
                        </_Builtin.Link>
                        <_Builtin.Link
                          className={_utils.cx(
                            _styles,
                            "nav-dropdown-link-3",
                            "mobile"
                          )}
                          button={false}
                          block="inline"
                          options={{
                            href: "https://engineears.com/booking-studio-sessions-for-labels",
                          }}
                        >
                          <_Builtin.Block tag="div">
                            {"Book Recording Studios"}
                          </_Builtin.Block>
                        </_Builtin.Link>
                        <_Builtin.Link
                          className={_utils.cx(
                            _styles,
                            "nav-dropdown-link-3",
                            "mobile"
                          )}
                          button={false}
                          block="inline"
                          options={{
                            href: "https://engineears.com/project-management-tools-for-labels",
                          }}
                        >
                          <_Builtin.Block tag="div">
                            {"Project Management Tools"}
                          </_Builtin.Block>
                        </_Builtin.Link>
                      </_Builtin.Block>
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Block>
              </_Builtin.Block>
              <_Builtin.Block className={_utils.cx(_styles, "hr")} tag="div" />
              <_Builtin.NavbarLink
                className={_utils.cx(_styles, "pop-out-menu-link")}
                options={{
                  href: "http://engineears.com/search",
                }}
              >
                {"Explore Profiles"}
              </_Builtin.NavbarLink>
              <_Builtin.NavbarLink
                className={_utils.cx(_styles, "pop-out-menu-link")}
                options={{
                  href: "http://engineears.com/community",
                }}
              >
                {"Community"}
              </_Builtin.NavbarLink>
              <_Builtin.NavbarLink
                className={_utils.cx(_styles, "pop-out-menu-link")}
                options={{
                  href: "https://support.engineears.com/en/knowledge-base",
                }}
              >
                {"Help"}
              </_Builtin.NavbarLink>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "div-block-116")}
              tag="div"
            >
              <_Builtin.NavbarLink
                className={_utils.cx(_styles, "nav-link-4", "outline")}
                options={{
                  href: "https://engineears.com/signup?flow=6&step=3",
                }}
              >
                {"Sign Up"}
              </_Builtin.NavbarLink>
              <_Builtin.NavbarLink
                className={_utils.cx(_styles, "nav-link-4")}
                options={{
                  href: "https://engineears.com/signin?flow=1&step=1",
                }}
              >
                {"Login"}
              </_Builtin.NavbarLink>
            </_Builtin.Block>
          </_Builtin.NavbarMenu>
          <_Builtin.NavbarButton
            className={_utils.cx(_styles, "", "menu-button-4")}
            tag="div"
          >
            <_Builtin.Icon
              widget={{
                type: "icon",
                icon: "nav-menu",
              }}
            />
          </_Builtin.NavbarButton>
        </_Builtin.Block>
      </_Builtin.NavbarWrapper>
      <_Builtin.Block className={_utils.cx(_styles, "flex-block-19")} tag="div">
        <_Builtin.Block
          className={_utils.cx(_styles, "category-wrapper")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "div-block-128")}
            tag="div"
          >
            <_Builtin.Link
              className={_utils.cx(_styles, "div-block-127")}
              button={false}
              block="inline"
              options={{
                href: "https://engineears.com/for-artists",
              }}
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "div-block-130")}
                tag="div"
              >
                <_Builtin.Image
                  loading="lazy"
                  width="auto"
                  height="auto"
                  alt=""
                  src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/67ca3b086f3140c39a80fac6_Icon.svg"
                />
              </_Builtin.Block>
              <_Builtin.Heading
                className={_utils.cx(_styles, "heading-48")}
                tag="h4"
              >
                {"For Artists"}
              </_Builtin.Heading>
            </_Builtin.Link>
            <_Builtin.Link
              className={_utils.cx(_styles, "nav-dropdown-link-3")}
              button={false}
              block="inline"
              options={{
                href: "https://engineears.com/customize-your-profile-for-artists",
              }}
            >
              <_Builtin.Block tag="div">{"Build Your Profile"}</_Builtin.Block>
            </_Builtin.Link>
            <_Builtin.Link
              className={_utils.cx(_styles, "nav-dropdown-link-3")}
              button={false}
              block="inline"
              options={{
                href: "https://engineears.com/booking-engineering-services",
              }}
            >
              <_Builtin.Block tag="div">
                {"Booking Engineering Services"}
              </_Builtin.Block>
            </_Builtin.Link>
            <_Builtin.Link
              className={_utils.cx(_styles, "nav-dropdown-link-3")}
              button={false}
              block="inline"
              options={{
                href: "https://engineears.com/booking-studio-sessions",
              }}
            >
              <_Builtin.Block tag="div">
                {"Book Recording Studios"}
              </_Builtin.Block>
            </_Builtin.Link>
            <_Builtin.Link
              className={_utils.cx(_styles, "nav-dropdown-link-3")}
              button={false}
              block="inline"
              options={{
                href: "https://engineears.com/project-management-tools-for-artists",
              }}
            >
              <_Builtin.Block tag="div">
                {"Project Management Tools"}
              </_Builtin.Block>
            </_Builtin.Link>
            <_Builtin.Link
              className={_utils.cx(_styles, "nav-dropdown-link-3")}
              button={false}
              block="inline"
              options={{
                href: "https://engineears.com/reporting-analytics-for-artists",
              }}
            >
              <_Builtin.Block tag="div">
                {"Reporting & Analytics"}
              </_Builtin.Block>
            </_Builtin.Link>
            <_Builtin.Link
              className={_utils.cx(_styles, "nav-dropdown-link-3")}
              button={false}
              block="inline"
              options={{
                href: "https://engineears.com/symphony",
              }}
            >
              <_Builtin.Block tag="div">{"Create Ad Campaigns"}</_Builtin.Block>
            </_Builtin.Link>
            <_Builtin.Link
              className={_utils.cx(_styles, "nav-dropdown-link-3")}
              button={false}
              block="inline"
              options={{
                href: "https://engineears.com/upstream",
              }}
            >
              <_Builtin.Block tag="div">{"Release Your Music"}</_Builtin.Block>
            </_Builtin.Link>
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, "div-block-129")}
            tag="div"
          >
            <_Builtin.Block className={_utils.cx(_styles, "hr")} tag="div" />
            <_Builtin.Block
              className={_utils.cx(_styles, "div-block-131")}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "div-block-132")}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "text-block-48")}
                  tag="div"
                >
                  {"For Artists"}
                </_Builtin.Block>
              </_Builtin.Block>
              <_Builtin.NotSupported _atom="LightboxWrapper" />
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
        <_Builtin.Block className={_utils.cx(_styles, "vhr")} tag="div" />
        <_Builtin.Block
          className={_utils.cx(_styles, "category-wrapper")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "div-block-128")}
            tag="div"
          >
            <_Builtin.Link
              className={_utils.cx(_styles, "div-block-127")}
              button={false}
              block="inline"
              options={{
                href: "https://engineears.com/for-engineers",
              }}
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "div-block-130")}
                tag="div"
              >
                <_Builtin.Image
                  loading="lazy"
                  width="auto"
                  height="auto"
                  alt=""
                  src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/67ca3b08f53a97b7279b6ca7_Icon-1.svg"
                />
              </_Builtin.Block>
              <_Builtin.Heading
                className={_utils.cx(_styles, "heading-48")}
                tag="h4"
              >
                {"For Audio Engineers"}
              </_Builtin.Heading>
            </_Builtin.Link>
            <_Builtin.Link
              className={_utils.cx(_styles, "nav-dropdown-link-3")}
              button={false}
              block="inline"
              options={{
                href: "https://engineears.com/build-your-profile-for-engineers",
              }}
            >
              <_Builtin.Block tag="div">{"Build Your Profile"}</_Builtin.Block>
            </_Builtin.Link>
            <_Builtin.Link
              className={_utils.cx(_styles, "nav-dropdown-link-3")}
              button={false}
              block="inline"
              options={{
                href: "https://engineears.com/project-management-tools",
              }}
            >
              <_Builtin.Block tag="div">
                {"Project Management Tools"}
              </_Builtin.Block>
            </_Builtin.Link>
            <_Builtin.Link
              className={_utils.cx(_styles, "nav-dropdown-link-3")}
              button={false}
              block="inline"
              options={{
                href: "https://engineears.com/reporting-analytics",
              }}
            >
              <_Builtin.Block tag="div">
                {"Reporting & Analytics"}
              </_Builtin.Block>
            </_Builtin.Link>
            <_Builtin.Link
              className={_utils.cx(_styles, "nav-dropdown-link-3")}
              button={false}
              block="inline"
              options={{
                href: "https://engineears.com/symphony",
              }}
            >
              <_Builtin.Block tag="div">{"Create Ad Campaigns"}</_Builtin.Block>
            </_Builtin.Link>
            <_Builtin.Link
              className={_utils.cx(_styles, "nav-dropdown-link-3")}
              button={false}
              block="inline"
              options={{
                href: "https://engineears.com/dolbyatmos",
              }}
            >
              <_Builtin.Block tag="div">{"Dolby Atmos Course"}</_Builtin.Block>
            </_Builtin.Link>
            <_Builtin.Link
              className={_utils.cx(_styles, "nav-dropdown-link-3")}
              button={false}
              block="inline"
              options={{
                href: "https://engineears.com/protools",
              }}
            >
              <_Builtin.Block tag="div">{"Pro Tools Course"}</_Builtin.Block>
            </_Builtin.Link>
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, "div-block-129")}
            tag="div"
          >
            <_Builtin.Block className={_utils.cx(_styles, "hr")} tag="div" />
            <_Builtin.Block
              className={_utils.cx(_styles, "div-block-131")}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "div-block-132")}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "text-block-48")}
                  tag="div"
                >
                  {"For Audio Engineers"}
                </_Builtin.Block>
              </_Builtin.Block>
              <_Builtin.NotSupported _atom="LightboxWrapper" />
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
        <_Builtin.Block className={_utils.cx(_styles, "vhr")} tag="div" />
        <_Builtin.Block
          className={_utils.cx(_styles, "category-wrapper")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "div-block-128")}
            tag="div"
          >
            <_Builtin.Link
              className={_utils.cx(_styles, "div-block-127")}
              button={false}
              block="inline"
              options={{
                href: "https://engineears.com/for-studios",
              }}
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "div-block-130")}
                tag="div"
              >
                <_Builtin.Image
                  loading="lazy"
                  width="auto"
                  height="auto"
                  alt=""
                  src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/67ca3b088baaecb3a94dc905_Icon-2.svg"
                />
              </_Builtin.Block>
              <_Builtin.Heading
                className={_utils.cx(_styles, "heading-48")}
                tag="h4"
              >
                {"For Recording Studios"}
              </_Builtin.Heading>
            </_Builtin.Link>
            <_Builtin.Link
              className={_utils.cx(_styles, "nav-dropdown-link-3")}
              button={false}
              block="inline"
              options={{
                href: "https://engineears.com/build-your-profile-for-studios",
              }}
            >
              <_Builtin.Block tag="div">{"Build Your Profile"}</_Builtin.Block>
            </_Builtin.Link>
            <_Builtin.Link
              className={_utils.cx(_styles, "nav-dropdown-link-3")}
              button={false}
              block="inline"
              options={{
                href: "https://engineears.com/session-management-tools",
              }}
            >
              <_Builtin.Block tag="div">
                {"Session Management Tools"}
              </_Builtin.Block>
            </_Builtin.Link>
            <_Builtin.Link
              className={_utils.cx(_styles, "nav-dropdown-link-3")}
              button={false}
              block="inline"
              options={{
                href: "https://engineears.com/studio-teams-resources",
              }}
            >
              <_Builtin.Block tag="div">
                {"Studio Team & Resources"}
              </_Builtin.Block>
            </_Builtin.Link>
            <_Builtin.Link
              className={_utils.cx(_styles, "nav-dropdown-link-3")}
              button={false}
              block="inline"
              options={{
                href: "https://engineears.com/reporting-analytics-for-studios",
              }}
            >
              <_Builtin.Block tag="div">
                {"Reporting & Analytics"}
              </_Builtin.Block>
            </_Builtin.Link>
            <_Builtin.Link
              className={_utils.cx(_styles, "nav-dropdown-link-3")}
              button={false}
              block="inline"
              options={{
                href: "https://engineears.com/symphony",
              }}
            >
              <_Builtin.Block tag="div">{"Create Ad Campaigns"}</_Builtin.Block>
            </_Builtin.Link>
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, "div-block-129")}
            tag="div"
          >
            <_Builtin.Block className={_utils.cx(_styles, "hr")} tag="div" />
            <_Builtin.Block
              className={_utils.cx(_styles, "div-block-131")}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "div-block-132")}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "text-block-48")}
                  tag="div"
                >
                  {"For Studios"}
                </_Builtin.Block>
              </_Builtin.Block>
              <_Builtin.NotSupported _atom="LightboxWrapper" />
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
        <_Builtin.Block className={_utils.cx(_styles, "vhr")} tag="div" />
        <_Builtin.Block
          className={_utils.cx(_styles, "category-wrapper")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "div-block-128")}
            tag="div"
          >
            <_Builtin.Link
              className={_utils.cx(_styles, "div-block-127")}
              button={false}
              block="inline"
              options={{
                href: "https://engineears.com/for-labels",
              }}
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "div-block-130")}
                tag="div"
              >
                <_Builtin.Image
                  loading="lazy"
                  width="auto"
                  height="auto"
                  alt=""
                  src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/67ca3b08f1ec198286a0b6a5_Icon-3.svg"
                />
              </_Builtin.Block>
              <_Builtin.Heading
                className={_utils.cx(_styles, "heading-48")}
                tag="h4"
              >
                {"For Record Labels"}
              </_Builtin.Heading>
            </_Builtin.Link>
            <_Builtin.Link
              className={_utils.cx(_styles, "nav-dropdown-link-3")}
              button={false}
              block="inline"
              options={{
                href: "https://engineears.com/getting-started-for-labels",
              }}
            >
              <_Builtin.Block tag="div">{"Getting Started"}</_Builtin.Block>
            </_Builtin.Link>
            <_Builtin.Link
              className={_utils.cx(_styles, "nav-dropdown-link-3")}
              button={false}
              block="inline"
              options={{
                href: "https://engineears.com/book-audio-engineering-services-for-labels",
              }}
            >
              <_Builtin.Block tag="div">
                {"Booking Engineering Services"}
              </_Builtin.Block>
            </_Builtin.Link>
            <_Builtin.Link
              className={_utils.cx(_styles, "nav-dropdown-link-3")}
              button={false}
              block="inline"
              options={{
                href: "https://engineears.com/booking-studio-sessions-for-labels",
              }}
            >
              <_Builtin.Block tag="div">
                {"Book Recording Studios"}
              </_Builtin.Block>
            </_Builtin.Link>
            <_Builtin.Link
              className={_utils.cx(_styles, "nav-dropdown-link-3")}
              button={false}
              block="inline"
              options={{
                href: "https://engineears.com/project-management-tools-for-labels",
              }}
            >
              <_Builtin.Block tag="div">
                {"Project Management Tools"}
              </_Builtin.Block>
            </_Builtin.Link>
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, "div-block-129")}
            tag="div"
          >
            <_Builtin.Block className={_utils.cx(_styles, "hr")} tag="div" />
            <_Builtin.Block
              className={_utils.cx(_styles, "div-block-131")}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "div-block-132")}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "text-block-48")}
                  tag="div"
                >
                  {"For Labels"}
                </_Builtin.Block>
              </_Builtin.Block>
              <_Builtin.NotSupported _atom="LightboxWrapper" />
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
      <_Builtin.Block
        className={_utils.cx(_styles, "div-block-134")}
        data-w-id="fe0f57d7-58a8-c969-2657-34205c1d78a8"
        tag="div"
      />
    </_Component>
  );
}
